import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Alert, AlertDescription, AlertTitle } from '@mdvip/shared/components/ui/alert';
import { useTranslation } from 'react-i18next';

/**
 * Renders when the member has no assigned practice on file (`NOT_FOUND`) — a reachable, calm state
 * rather than a failure: `info` variant and copy that doesn't read as an error, per the ticket's
 * resolved conflict (no definitive answer on how often this is reachable, but the shipped backend
 * makes it concretely so).
 */
export function PracticeInfoEmpty() {
  const { t } = useTranslation('members');
  return (
    <Alert variant="info" data-slot="practice-info-empty">
      <Icon name="info" />
      <AlertTitle>{t('profile.practiceUnavailable.title')}</AlertTitle>
      <AlertDescription>{t('profile.practiceUnavailable.body')}</AlertDescription>
    </Alert>
  );
}
